const LocalStorageUtility =
{
    get(key: string): string | undefined {
        return localStorage.getItem(key) || undefined;
    },
    set(key: string, value: any): void {
        return localStorage.setItem(key, value);
    },
    getObject<T>(key: string): T | undefined {
        const storageValue = localStorage.getItem(key);
        if (!storageValue)
            return undefined;

        return JSON.parse(storageValue) as T;
    },
    setObject(key: string, value: any): void {
        return localStorage.setItem(key, JSON.stringify(value));
    },
    remove(key: string) {
        localStorage.removeItem(key);
    },
    clear() {
        localStorage.clear();
    },
    setWithExpiry(key: string, value: any, ttl: any): void {
        const now = new Date();

        const item = {
            value: value,
            expiry: now.getTime() + ttl
        };

        localStorage.setItem(key, JSON.stringify(item));
    },    
    getWithExpiry<T>(key: string): T | undefined {
        const itemStr = localStorage.getItem(key);

        if (!itemStr) {
            return undefined;
        }

        const item = JSON.parse(itemStr);
        const now = new Date();

        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return undefined;
        }
        
        return item.value as T;
    }
}

export default LocalStorageUtility;